"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractServiceFacade = _interopRequireDefault(require("../AbstractServiceFacade"));

var _ServiceFacadeException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceFacadeException"));

var _ServiceFactory = _interopRequireDefault(require("../ServiceFactory"));

var _LocalizationUtility = _interopRequireDefault(require("../util/LocalizationUtility"));

var _ArticleServiceConfig = _interopRequireDefault(require("../service/article/ArticleServiceConfig"));

var _LocalizationServiceFacade = _interopRequireDefault(require("./LocalizationServiceFacade"));

var _ApplicationUrlServiceFacade = _interopRequireDefault(require("./ApplicationUrlServiceFacade"));

var _Console = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/Console"));

var _ApiPlatformConstant = _interopRequireDefault(require("../constant/ApiPlatformConstant"));

var _ProductDataSourceConstant = _interopRequireDefault(require("../constant/ProductDataSourceConstant"));

var _ServiceException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceException"));

var _ServiceSettings = _interopRequireDefault(require("../ServiceSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This class is used as a simple interface for product articles.
 */
var ArticleServiceFacade = /*#__PURE__*/function (_AbstractServiceFacad) {
  _inherits(ArticleServiceFacade, _AbstractServiceFacad);

  var _super = _createSuper(ArticleServiceFacade);

  function ArticleServiceFacade() {
    _classCallCheck(this, ArticleServiceFacade);

    return _super.apply(this, arguments);
  }

  _createClass(ArticleServiceFacade, null, [{
    key: "getArticles",

    /**
     * Fetches product article items.
     *
     * @param {object[]} items Array of items.
     * @param {object} [options] Options object.
     * @param {object} [options.fields=null] List of DEXF fields to be included in response.
     * @param {boolean} [options.useBulkFetch=false] Set to "true" to fetch all articles for an application when using DEXF config service.
     * @returns {Promise} Promise object.
     */
    value: function getArticles(items) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (items.length === 0) {
        return Promise.resolve([]);
      }

      return new Promise(function (resolve, reject) {
        _this._getQueuePromise({
          items: items,
          resolve: resolve,
          reject: reject
        }).then(function (_ref) {
          var queue = _ref.queue,
              allItems = _ref.allItems;
          var promises = [_LocalizationServiceFacade.default.getData(), _ApplicationUrlServiceFacade.default.getUrls()];
          var fields = options && options.fields ? options.fields : null;
          var useBulkFetch = options && options.useBulkFetch ? true : false;

          var handleError = function handleError(error) {
            _this.clearCache(error);

            var _iterator = _createForOfIteratorHelper(queue),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var queueItem = _step.value;
                queueItem.reject(error);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          };

          Promise.all(promises).then(function (responses) {
            var local = responses[0];
            var urls = responses[1];
            var fetchItems = [];
            var articlesPromises = [];

            var serviceConfig = _this._getServiceConfig(local, urls, fields); // Checks against cache and diff which items to fetch
            // Creates promises for items that are in cache or are pending


            var _iterator2 = _createForOfIteratorHelper(allItems.values()),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var item = _step2.value;

                var cachedItem = _this.getCacheItem(item);

                if (cachedItem) {
                  articlesPromises.push(_this._getCachePromise(item, false).then(function (article) {
                    return [article];
                  }));
                } else {
                  fetchItems.push(item);

                  _this.setCacheItemAsWaiting(item);
                }
              } // Items to fetch

            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            if (fetchItems.length > 0) {
              var service = _this._getArticleService(serviceConfig);

              var factoryName = service.constructor.factoryName;

              if (useBulkFetch && factoryName === 'dexfwebplanner' || factoryName === 'wprwretailitem') {
                articlesPromises.push(service.getApplicationItems(serviceConfig));
              } else {
                articlesPromises.push(service.getItems(serviceConfig, fetchItems));
              }
            }

            Promise.all(articlesPromises).then(function (responses) {
              var articles = [].concat.apply([], responses); // Store articles in cache

              var _iterator3 = _createForOfIteratorHelper(articles),
                  _step3;

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var article = _step3.value;

                  if (article) {
                    var type = article.ItemType.toUpperCase();
                    var itemGlobalId = type + article.GlobalID;
                    var itemLocalId = type + article.LocalID;
                    allItems.delete(itemLocalId);
                    allItems.delete(itemGlobalId);

                    if (article.GlobalID !== article.LocalID) {
                      _this.setCacheItem({
                        id: article.GlobalID,
                        type: type
                      }, article);

                      _this.setCacheItem({
                        id: article.LocalID,
                        type: type
                      }, article);
                    } else {
                      _this.setCacheItem({
                        id: article.GlobalID,
                        type: type
                      }, article);
                    }
                  }
                } // Store not found articles in cache

              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }

              var _iterator4 = _createForOfIteratorHelper(allItems.values()),
                  _step4;

              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  var item = _step4.value;

                  _this.setCacheItemAsNotFound(item);
                } // Put articles into waiting queue items

              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }

              var _iterator5 = _createForOfIteratorHelper(articles),
                  _step5;

              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  var _article = _step5.value;

                  if (_article) {
                    var _type = _article.ItemType.toUpperCase();

                    var _itemGlobalId = _type + _article.GlobalID;

                    var _itemLocalId = _type + _article.LocalID;

                    for (var i = 0, max = queue.length; i < max; i++) {
                      var queueItem = queue[i];

                      if (queueItem.items.get(_itemGlobalId) || queueItem.items.get(_itemLocalId)) {
                        queueItem.items.delete(_itemGlobalId);
                        queueItem.items.delete(_itemLocalId);
                        queueItem.articles.push(_article);

                        if (queueItem.items.size === 0) {
                          queueItem.resolve(_this._sortArticlesByItems(queueItem.articles, queueItem.itemsArray));
                          queue.splice(i, 1);
                          i--;
                          max--;
                        }
                      }
                    }
                  }
                } // Resolves remaining in queue

              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }

              var _iterator6 = _createForOfIteratorHelper(queue),
                  _step6;

              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  var _queueItem = _step6.value;

                  _queueItem.resolve(_this._sortArticlesByItems(_queueItem.articles, _queueItem.itemsArray));
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
            }).catch(handleError);
          }).catch(handleError);
        }).catch(reject);
      });
    }
    /**
     * Fetches a single product article item.
     *
     * @example ArticleServiceFacade.getArticle({ type: 'ART', id: '123456' }).then(article => {
     * // Handle article
     * }).catch(error => {
     * // Handle error
     * });
     * @param {object} item Item to get.
     * @param {string} item.type Item type.
     * @param {number} item.id Item id.
     * @param {object} [options] Options object.
     * @param {object} [options.fields] List of DEXF fields to be included in response.
     * @param {object} [options.useBulkFetch] Attempts to fetch all for an application by using DEXF config service.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "getArticle",
    value: function getArticle(item, options) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.getArticles([item], options).then(function (articles) {
          resolve(articles[0] || null);
        }).catch(reject);
      });
    }
    /**
     * Returns an Array of cached articles based on items sent.
     * Returns null if it is missing and a fetch is required.
     *
     * @param {object} items Items to find.
     * @returns {object[]|null} Cached articles.
     */

  }, {
    key: "getCachedArticles",
    value: function getCachedArticles(items) {
      var articles = [];

      var _iterator7 = _createForOfIteratorHelper(items),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var item = _step7.value;
          var article = this.getCacheItem(item);

          if (!article || article.isWaiting) {
            return null;
          }

          if (!article.isNotFound) {
            articles.push(article);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      return articles;
    }
    /**
     * Returns an article from cache.
     * Returns null if it is missing and a fetch is required.
     *
     * @param {object} item Item to find.
     * @returns {object|null} Cached articles.
     */

  }, {
    key: "getCachedArticle",
    value: function getCachedArticle(item) {
      var articles = this.getCachedArticles([item]);
      return articles && articles.length > 0 ? articles[0] : null;
    }
    /**
     * Loads raw data into cache.
     *
     * @param {object[]} rawData Array of items returned from RetailItemComm, WPRW or DEXF.
     * @param {string} productDataSource Apply ProductDataSource in case not part of localizations, supperted values are RetailItemComm, WPRW or DEXF.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "cacheRawData",
    value: function cacheRawData(rawData) {
      var _this3 = this;

      var productDataSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return new Promise(function (resolve, reject) {
        _LocalizationServiceFacade.default.getData().then(function (data) {
          _ApplicationUrlServiceFacade.default.getUrls().then( /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(urls) {
              var serviceConfig, service, parser, _iterator8, _step8, article;

              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      serviceConfig = _this3._getServiceConfig(data, urls);

                      if (productDataSource) {
                        serviceConfig.productDataSource = productDataSource;
                      }

                      service = _this3._getArticleService(serviceConfig);
                      parser = service.getParser(serviceConfig);
                      _context.t0 = _createForOfIteratorHelper;
                      _context.next = 7;
                      return parser.parse(rawData);

                    case 7:
                      _context.t1 = _context.sent;
                      _iterator8 = (0, _context.t0)(_context.t1);

                      try {
                        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                          article = _step8.value;

                          _this3.setCacheItem({
                            type: article.ItemType,
                            id: article.GlobalID
                          }, article);

                          if (article.GlobalID !== article.LocalID) {
                            _this3.setCacheItem({
                              type: article.ItemType,
                              id: article.LocalID
                            }, article);
                          }
                        }
                      } catch (err) {
                        _iterator8.e(err);
                      } finally {
                        _iterator8.f();
                      }

                      resolve();

                    case 11:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref2.apply(this, arguments);
            };
          }()).catch(reject);
        }).catch(reject);
      });
    }
    /**
     * Handles a queue when called with multiple requests synchronously.
     *
     * @param {object} options Options object.
     * @param {object[]} options.items Array of items.
     * @param {Function} options.resolve Function to call to resolve a queue item.
     * @param {Function} options.reject Function to call to reject a queue item.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_getQueuePromise",
    value: function _getQueuePromise(options) {
      var _this4 = this;

      return new Promise(function (resolve) {
        var queueItem = {
          resolve: options.resolve,
          reject: options.reject,
          items: _this4._getItemsMap(options.items),
          itemsArray: options.items.slice(),
          articles: []
        };

        if (_ServiceSettings.default.disableArticleQueue) {
          resolve({
            queue: [queueItem],
            allItems: _this4._getItemsMap(options.items)
          });
        } else {
          _this4._storeQueueItem(queueItem);

          if (_this4._previousQueueResolve) {
            _this4._previousQueueResolve({
              allItems: new Map(),
              queue: []
            });
          }

          clearTimeout(_this4._timeout);
          _this4._previousQueueResolve = resolve;
          _this4._timeout = setTimeout(function () {
            return resolve(_this4._retrieveStoredQueueItems());
          });
        }
      });
    }
    /**
     * Returns a map of items.
     *
     * @param {object[]} items Array of items.
     * @returns {Map} Map of items.
     */

  }, {
    key: "_getItemsMap",
    value: function _getItemsMap(items) {
      var itemsMap = new Map();

      var _iterator9 = _createForOfIteratorHelper(items),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var item = _step9.value;

          if (typeof item.type !== 'string') {
            throw new _ServiceException.default('Expected "type" property to be a string, but type was "' + _typeof(item.type) + '". Id on item: ' + item.id, this.serviceName);
          }

          if (typeof item.id !== 'string') {
            _Console.default.warn('Expected "id" property to be a string, but type was "' + _typeof(item.id) + '". Converting property to string. Id on item: ' + item.id);
          }

          var newItem = {
            id: String(item.id),
            type: String(item.type).toUpperCase()
          };
          itemsMap.set(newItem.type + newItem.id, newItem);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      return itemsMap;
    }
    /**
     * Stores a queue item.
     *
     * @param {object} queueItem Queue item object.
     */

  }, {
    key: "_storeQueueItem",
    value: function _storeQueueItem(queueItem) {
      this._allItems = this._allItems;
      this._queue = this._queue;

      this._queue.push(queueItem);

      var _iterator10 = _createForOfIteratorHelper(queueItem.items.values()),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var item = _step10.value;
          var itemId = item.type + item.id;

          if (!this._allItems.get(itemId)) {
            this._allItems.set(itemId, item);
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
    /**
     * Stores a queue item.
     *
     * @returns {{ allItems: Map, queue: Array }} Queue items.
     */

  }, {
    key: "_retrieveStoredQueueItems",
    value: function _retrieveStoredQueueItems() {
      var allItems = this._allItems;
      var queue = this._queue;
      this._allItems = new Map();
      this._queue = [];
      return {
        allItems: allItems,
        queue: queue
      };
    }
    /**
     * Returns properties to use if cache key is object.
     *
     * @override
     * @returns {string[]} Properties to use if cache key is an object. Default is to use the entire object.
     */

  }, {
    key: "_getServiceConfig",

    /**
     * Returns the ArticleServiceConfig.
     *
     * @param {Obejct} common Common localization settings and translations.
     * @param {Obejct} urls The urls object config for ArticleService.
     * @param {string[]} fields List of DEXF fields to be included in response.
     * @returns {ArticleServiceConfig} ArticleServiceConfig.
     */
    value: function _getServiceConfig(common, urls, fields) {
      var serviceConfig = new _ArticleServiceConfig.default();
      serviceConfig.apiPlatform = common.localization.apiPlatform;
      serviceConfig.apiLocalePath = common.localization.usesSubDomain && common.localization.locale ? common.localization.locale.toLowerCase().split('_').reverse().join('/') : common.apiLocalePath;
      serviceConfig.subDomain = common.localization.usesSubDomain && common.localization.locale ? common.localization.locale.split('_')[0] : null;
      serviceConfig.productInfoPageUrl = urls.PIP;
      serviceConfig.productDataSource = this._getProductDataSource(common);
      serviceConfig.endpoints = common.endpoints;
      serviceConfig.dexfApiKey = this._getDexfApiKey(common);
      serviceConfig.fields = fields;
      return serviceConfig;
    }
    /**
     * Returns the service.
     *
     * @param {ArticleServiceConfig} serviceConfig The service config for ArticleService.
     * @returns {string} Service name.
     */

  }, {
    key: "_getArticleService",
    value: function _getArticleService(serviceConfig) {
      if (serviceConfig.productDataSource === _ProductDataSourceConstant.default.DEXF || serviceConfig.apiPlatform === _ApiPlatformConstant.default.dexf) {
        return _ServiceFactory.default.getService('dexfwebplanner');
      } else if (serviceConfig.productDataSource === _ProductDataSourceConstant.default.WPRW || serviceConfig.apiPlatform === _ApiPlatformConstant.default.roig) {
        return _ServiceFactory.default.getService('wprwretailitem');
      } else if (serviceConfig.productDataSource === _ProductDataSourceConstant.default.RIC || serviceConfig.apiPlatform === _ApiPlatformConstant.default.irw || serviceConfig.apiPlatform === _ApiPlatformConstant.default.nwp) {
        return _ServiceFactory.default.getService(serviceConfig.apiPlatform + 'retailitem');
      } else {
        throw new _ServiceFacadeException.default('Failed to get articles. Platform with name "' + serviceConfig.apiPlatform + '" is not supported.', this.constructor.serviceName);
      }
    }
    /**
     * Returns the service.
     *
     * @param {object} localizationData Localization data from LocalizationService.
     * @returns {string} ProductDataSource, such as RetailItemComm,DEXF,WPRW or default.
     */

  }, {
    key: "_getProductDataSource",
    value: function _getProductDataSource(localizationData) {
      return _LocalizationUtility.default.getAppSettingValue(localizationData, 'productDataSource') || 'default';
    }
    /**
     * Returns the service.
     *
     * @param {object} localizationData Localization data from LocalizationService.
     * @returns {string} DexfApiKey, public api key for the application.
     */

  }, {
    key: "_getDexfApiKey",
    value: function _getDexfApiKey(localizationData) {
      return _LocalizationUtility.default.getAppSettingValue(localizationData, 'dexfApiKey');
    }
    /**
     * Sorts items in the same order as matchArray.
     *
     * @param {object[]} articles Array of items to sort.
     * @param {object[]} items Array of items to sort after.
     * @returns {object[]} Sorted articles.
     */

  }, {
    key: "_sortArticlesByItems",
    value: function _sortArticlesByItems(articles, items) {
      var sortedArticles = [];
      var articlesMap = {};

      for (var i = 0, max = articles.length; i < max; i++) {
        if (articles[i].GlobalID) {
          articlesMap[articles[i].GlobalID] = articles[i];
        }

        if (articles[i].LocalID && (!articles[i].GlobalID || articles[i].LocalID !== articles[i].GlobalID)) {
          articlesMap[articles[i].LocalID] = articles[i];
        }
      }

      for (var _i = 0, _max = items.length; _i < _max; _i++) {
        var article = articlesMap[items[_i].id];

        if (article) {
          sortedArticles.push(article);
        }
      }

      return sortedArticles;
    }
  }, {
    key: "cacheKeyProperties",
    get: function get() {
      return ['id', 'type'];
    }
    /**
     * Sets cache expire time in ms.
     *
     * @override
     * @param {number} cacheExpireTime Cache expire time in ms.
     */

  }, {
    key: "cacheExpireTime",
    set: function set(cacheExpireTime) {
      this._cacheExpireTime = cacheExpireTime;
    }
    /**
     * Returns cache expire time in ms.
     *  - "0" will disable caching.
     *  - "-1" will cache it the entire session.
     *
     * @override
     * @returns {number} Cache expire time in ms. Returns -1 for article service by default.
     */
    ,
    get: function get() {
      return typeof this._cacheExpireTime === 'number' ? this._cacheExpireTime : -1;
    }
    /**
     * Returns the service name.
     *
     * @override
     * @returns {string} Service name.
     */

  }, {
    key: "serviceName",
    get: function get() {
      return 'ArticleServiceFacade';
    }
  }]);

  return ArticleServiceFacade;
}(_AbstractServiceFacade.default);

exports.default = ArticleServiceFacade;

_defineProperty(ArticleServiceFacade, "_allItems", new Map());

_defineProperty(ArticleServiceFacade, "_queue", []);

_defineProperty(ArticleServiceFacade, "_timeout", null);

_defineProperty(ArticleServiceFacade, "_previousQueueResolve", null);